<ng-template #content>
  <div class="gw-flex gw-items-center gw-gap-3">
    <tui-avatar
      *ngIf="photo"
      [src]="row?.logo || row?.name | tuiInitials"
      [size]="size === 's' ? 's' : size === 'l' ? 'l' : 'm'"
      [style.color]="'var(--tui-text-primary-on-accent-1)'"
      class="gw-flex-shrink-0 gw-avatar-bg g"
      tuiAvatarOutline
    ></tui-avatar>

    <div class="gw-flex gw-flex-col gw-min-w-0 gw-flex-1">
      <span
        [class.gw-text-sm]="smallFont"
        class="gw-text-text-primary gw-font-semibold gw-truncate"
      >
        {{ displayName }}
      </span>
      <span
        [class.gw-text-xs]="smallFont"
        class="gw-text-text-secondary gw-truncate"
      >
        {{ row.document | document : true }}
      </span>
      <span
        *ngIf="email || row?.email"
        [class.gw-text-xs]="smallFont"
        class="gw-text-text-tertiary gw-truncate"
      >
        {{ email || row?.email }}
      </span>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="type !== undefined; else plainContent">
  <a
    href="javascript:void(0)"
    (click)="onClick()"
    class="gw-text-text-primary hover:gw-text-text-action gw-transition-colors"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-template #plainContent>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>
